module.exports = __webpack_public_path__ + "static/img/freone.65781d10.png";